import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mcLogin } from "../../../business/redux/reducers/mcOpsDashboard/actions";

/**
 * Email/password gate for the MC Ops dashboard — the same stage login. On
 * success the returned Bearer token is stored and the dashboard loads scoped to
 * that coordinator. Shown when there is no token or the API answered 401.
 */
export const LoginGate = ({ onLoggedIn }) => {
  const dispatch = useDispatch();
  const authError = useSelector((s) => s.mcOpsDashboard?.meta?.authError);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password || busy) return;
    setBusy(true);
    const ok = await dispatch(mcLogin({ email, password }));
    setBusy(false);
    if (ok && onLoggedIn) onLoggedIn();
  };

  return (
    <div className="mc-ops-root">
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg,#0b1e46,#12275c)",
        }}
      >
        <form
          onSubmit={submit}
          style={{
            width: 340,
            background: "#fff",
            borderRadius: 16,
            padding: "28px 26px",
            boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          }}
        >
          <div style={{ fontSize: 18, fontWeight: 800, color: "#12275c" }}>
            Move Coordinator Operations
          </div>
          <div style={{ fontSize: 12.5, color: "#6b7a90", margin: "4px 0 20px" }}>
            Sign in with your Roadway account.
          </div>

          <label style={{ fontSize: 12, fontWeight: 700, color: "#42506a" }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            style={inputStyle}
            placeholder="you@roadwaymoving.com"
          />

          <label style={{ fontSize: 12, fontWeight: 700, color: "#42506a" }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
            placeholder="••••••••"
          />

          {authError ? (
            <div style={{ color: "#c0392b", fontSize: 12, margin: "2px 0 10px" }}>
              {authError}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={busy || !email || !password}
            style={{
              width: "100%",
              marginTop: 8,
              padding: "11px 0",
              borderRadius: 10,
              border: "none",
              background: busy ? "#7c8db8" : "#2f66f6",
              color: "#fff",
              fontWeight: 700,
              fontSize: 14,
              cursor: busy ? "default" : "pointer",
            }}
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  margin: "5px 0 14px",
  padding: "10px 12px",
  borderRadius: 9,
  border: "1px solid #d8dfec",
  fontSize: 13.5,
  outline: "none",
};
